import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Start', id: 'hero' },
    { label: 'Über mich', id: 'about' },
    { label: 'Leistungen', id: 'services' },
    { label: 'Projekte', id: 'portfolio' },
    { label: 'Kontakt', id: 'contact' }
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-[#F8FAFC]/90 backdrop-blur-md border-b border-[#E2E8F0]' : 'bg-[#F8FAFC]/95 backdrop-blur-md'
        }`}
      >
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-xl font-bold text-black hover:text-gray-700 transition-colors relative z-[60]"
            >
              WebWerk
            </button>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-1">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="px-4 py-2 text-gray-600 hover:text-black font-medium transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </nav>

            <Button
              onClick={() => scrollToSection('contact')}
              className="hidden md:inline-flex bg-[#1E40AF] hover:bg-[#1E3A8A] text-white transition-all px-6 py-5 font-semibold"
            >
              Anfragen
            </Button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-black hover:text-gray-700 transition-colors relative z-[60]"
              aria-label="Menü öffnen"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Navigation - Full screen overlay - OUTSIDE header */}
      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 z-[55] pt-[72px] bg-[#F8FAFC]">
          <nav className="py-6 px-6 h-full">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left px-4 py-5 text-gray-700 hover:text-black hover:bg-[#F1F5F9] font-medium transition-colors text-xl border-b border-[#E2E8F0]"
              >
                {item.label}
              </button>
            ))}
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full mt-6 bg-[#1E40AF] hover:bg-[#1E3A8A] text-white transition-colors py-5 text-lg"
            >
              Anfragen
            </Button>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;